<template>
  <div class="booxVersions app-container">
    <div class="global-header-wrap">
      <h3>手机助手版本管理</h3>
      <div class="booxVersions-header-right">
        <button
          class="global-button-style"
          @click="$router.push({ name: 'booxVersionsCreate' })"
        >
          新增
        </button>
      </div>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <!-- <div slot="header">
        <div class="global-table-header">
          <div class="booxVersions-header-btn-left">
            <list-search ref="listSearch" @listSearchEvn="listSearchFun" />
          </div>
        </div>
      </div> -->
      <div class="global-body-wrap">
        <appTable
          :tableData="tableData"
          :tableProps="tableProps"
          :selectCtrl="false"
          @tableHandle="tableHandle"
        />
      </div>
      <pagination
        :pageSize="params.limit"
        :total="total"
        @pageNum="getPageNum"
      />
    </el-card>
    <el-dialog
      title="版本详情"
      :visible.sync="centerDialogVisible"
      width="50%"
      center
    >
      <div v-if="tagItem">
        <div class="booxVersions-dialog-item">
          <p>包名</p>
          <p>{{ tagItem.package }}</p>
        </div>
        <div class="booxVersions-dialog-item">
          <p>版本号</p>
          <p>{{ tagItem.version }}</p>
        </div>
        <div class="booxVersions-dialog-item">
          <p>链接</p>
          <p v-if="tagItem.url">{{ tagItem.url }}</p>
          <p v-else>无</p>
        </div>
        <div class="booxVersions-dialog-item">
          <p>类型</p>
          <p>{{ tagItem.type }}</p>
        </div>
        <div class="booxVersions-dialog-item">
          <p>是否强制更新</p>
          <p>{{ tagItem.force | filterUpdateTypes }}</p>
        </div>
        <div class="booxVersions-dialog-item">
          <p>描述</p>
          <p
            v-if="tagItem.description"
            v-html="filterDesc(tagItem.description)"
          ></p>
          <p v-else>无</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import listSearch from "@/components/listSearch";
import appTable from "@/components/appTable";
import pagination from "@/components/pagination";
import listMixin from "@/mixins/list";
export default {
  components: {
    listSearch,
    appTable,
    pagination
  },
  computed: {
    rules() {
      let rules = {
        name: [
          { required: true, message: this.$t("verify.tag"), trigger: "blur" }
        ]
        // models: [
        //   { required: true, message: this.$t("verify.tag"), trigger: "blur" }
        // ]
      };
      return rules;
    },
    tableProps() {
      let tableProps = [
        {
          prop: "type",
          label: "类型"
        },
        {
          prop: "package",
          label: "包名"
        },
        {
          prop: "version",
          label: "版本号"
        },
        {
          prop: "force",
          label: "是否强制更新"
        },
        {
          prop: "updatedAt",
          label: "创建时间"
        },
        {
          prop: "handle",
          label: this.$t("commonMsg.handle"),
          width: 220,
          btn: [
            this.$t("commonMsg.edit"),
            this.$t("commonMsg.checkDetails"),
            this.$t("commonMsg.del")
          ]
        }
      ];
      return tableProps;
    }
  },
  mixins: [listMixin],
  data() {
    return {
      params: {
        limit: 20,
        page: 1,
        sortBy: "updatedAt"
      },
      tableData: [],
      total: 0,
      title: "",
      tagItem: null,
      centerDialogVisible: false
    };
  },
  methods: {
    filterDesc(desc) {
      let val = desc ? desc.replace(/\n/g, "<br>") : "";
      return val;
    },
    getList() {
      this.$http.getBooxVersions(this.params).then(res => {
        this.tableData = res.data.results;
        this.total = res.data.count;
      });
    },

    del(data) {
      this.$http.delBooxVersions(data.row._id).then(res => {
        this.elMsg(this.$t("alertMsg.delSuccess"), "success");
        this.tableData.splice(data.$index, 1);
      });
    },

    toDetails(data) {
      this.tagItem = data.row;
      this.centerDialogVisible = true;
    },

    edit(data) {
      this.$router.push({
        name: "booxVersionsCreate",
        query: { id: data.row._id }
      });
    },

    listSearchFun(val) {
      if (val) {
        this.params.name = val;
      } else {
        delete this.params.name;
      }
      this.params.page = val;
      this.getList();
    },

    getPageNum(val) {
      this.params.page = val;
      this.getList();
    }
  }
};
</script>

<style lang="scss">
.booxVersions {
  .booxVersions-btn {
    text-align: right;
    padding: 10px;
  }
  .booxVersions-pagination {
    padding: 10px;
    text-align: right;
  }
  .booxVersions-dialog-item {
    padding: 10px 0;
    line-height: 25px;
    > p:first-child {
      font-weight: bold;
    }
    .booxVersions-dialog-des {
      overflow: hidden;
      > p {
        > img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
